import { Image, Typography } from 'antd';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { DASHBOARD_APP_NAME } from 'src/app/constants';
import styles from './Product.module.css';
import useWindowDimensions from 'src/hooks/useWindowDimensions';

const { Title } = Typography;

const ProductName = () => {
  const { width } = useWindowDimensions();

  const isMobile = width <= 769;
  return (
    <div>
      <Link to="/dashboard">
        <div className="flex">
          <img src="/Blue_small use.png" className={styles['ProductName--Image']} />
          <Title className={classNames(styles.ProductName, 'text-light-gray2')}>
            {isMobile ? 'JLR VFDB' : DASHBOARD_APP_NAME}
          </Title>
        </div>
      </Link>
    </div>
  );
};

export default ProductName;
